var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"width":"120px","height":"120px"},attrs:{"id":_vm.id}})])
}
var staticRenderFns = []

export { render, staticRenderFns }